<template>
    <div class="browser-selector-inline">
        <a-select
            mode="multiple"
            v-model="selectedBrowser"
            style="width: 100%"
            :filter-option="false"
            @search="getBrowserBySearch"
            @change="() => getBrowserBySearch()"
            :not-found-content="fetching ? undefined : null"
        >
            <a-spin v-if="fetching" slot="notFoundContent" size="small" />
            <a-select-option v-for="item of items" :key="item.key" :value="item.key">
                {{ item.value }}
            </a-select-option>
        </a-select>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "BrowserSelectorInline",
    props: {
        value: {
            type: Array,
            default: () => [],
        },
    },
    data: () => ({
        fetching: false,
        selectedBrowser: [],
        items: [],
        searchTimeout: null,
    }),
    mounted() {
        if (Array.isArray(this.value)) this.selectedBrowser = this.value;
        this.getBrowserBySearch();
    },
    methods: {
        ...mapActions({
            getContactByField: "visitor/getContactByField",
        }),
        getBrowserBySearch(query) {
            if (this.searchTimeout) clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
                this.fetching = true;
                this.getContactByField({ field: "browser", query }).then((items) => {
                    this.items = this.$_.uniq(items).map((item) => ({
                        key: item,
                        value: item,
                    }));
                    this.fetching = false;
                });
            }, 500);
        },
    },
    watch: {
        selectedBrowser() {
            this.$emit("input", this.selectedBrowser);
        },
        value() {
            this.selectedBrowser = this.value;
        },
    },
};
</script>
